import { Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { TooltipProps } from 'recharts';

export const FundComparatorChartTooltip: React.FC<TooltipProps<any, any>> = ({ payload }) => {
  return (
    <Shadow level={1} padding="inset.xs" borderRadius="sm" minWidth="222px" maxWidth="222px">
      <VStack space="stack.quarck">
        {payload?.map((item) => (
          <HStack key={item.dataKey} alignItems="center" space="stack.quarck">
            <Box
              w="8px"
              height="8px"
              background={item.color}
              borderRadius="full"
              mr="inline.nano"
            />
            <Text flex={1} numberOfLines={1} ellipsizeMode="tail">
              {item.name}
            </Text>
            <Icon
              name={item.value >= 0 ? 'ArrowUp' : 'ArrowDown'}
              size="xxs"
              color={item.value >= 0 ? 'feedback.success.default' : 'feedback.error.default'}
            />
            <Text>{Utils.Mask.Percentage(item.value)}</Text>
          </HStack>
        ))}
      </VStack>
    </Shadow>
  );
};
